import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import ConfirmPostDialog from '../modals/ConfirmPostDialog';

const DropDownPostDeleteItem = (props) => {

    const [postId, setPostId] = useState("");
    const [indexx, setIndexx] = useState("");
    const [confirmation, setConfirmation] = useState(false);
    const [isPostConfirmDailogOpen, setPostConfirmDailogOpen] = useState(false);

    const handlePostConfirmDialogClose = (event, reason) => {
	    setPostConfirmDailogOpen(false);
        setConfirmation(false);
	}

    const deletePostConfirmation = (ptId, index) => {
        setPostId(ptId);
        setIndexx(index + 1)
        setPostConfirmDailogOpen(true);
    }

    return (
        <>
            <Link 
                to="#"
                onClick={() => deletePostConfirmation(props.post.id, props.index)}
            > 
                <i className="fas fa-trash"></i> Delete Post 
            </Link>  
            {postId && indexx && (
                <ConfirmPostDialog 
                    dialogIsOpen={isPostConfirmDailogOpen} 
                    handleDialogClose={handlePostConfirmDialogClose} 
                    setDialogIsOpen={setPostConfirmDailogOpen} 
                    postId={postId}
                    confirmation={confirmation} 
                    setConfirmation={setConfirmation}
                    setDeletedIndex={props.setDeletedIndex}
                    index={indexx}
                />
            )}
        </>
    );
};

export default DropDownPostDeleteItem;